{
  "russet": { "label": "Russet", "colour": "#8b4c2e" },
  "woad": { "label": "Woad blue", "colour": "#40587a" },
  "madder": { "label": "Madder red", "colour": "#99382a" },
  "green": { "label": "Moss green", "colour": "#5d6b3d" },
  "weld": { "label": "Weld yellow", "colour": "#b39340" },
  "black": { "label": "Charcoal", "colour": "#2c2927" }
}
